var baseSetToString=require("./_baseSetToString"),shortOut=require("./_shortOut"),setToString=shortOut(baseSetToString);module.exports=setToString;